module.exports = __webpack_public_path__ + "img/adm.b6f7fcd0.jpg";